<template>
  <div>
    <!-- Show Extensiv auth ONLY when on /extensiv routes 
    <Auth 
      v-if="!authenticated && $route.path.startsWith('/extensiv')" 
      :loading="loading" 
      :handleAuthLink="openAuth" 
    />
    -->
    <!-- For Extensiv (or any non-Extensiv path) → skip auth and show content directly -->
    <router-view></router-view>
  </div>
</template>

<script>
import Auth from './components/Auth';

import { mapGetters, mapActions } from 'vuex';
import * as type from '../../store/types';

export default {
    components: {  },
    computed: {
        ...mapGetters({
            authenticated: `extensiv/authenticated`,
            loading: `global/loading`
        })
    },
    created(){
        //this.connectAuth();
    },
    methods: {
        ...mapActions({
            //connectAuth: `extensiv/${type.Extensiv_CONNECT}`,
            //openAuth: `extensiv/${type.Extensiv_OPEN_AUTH}`,
            
        })
    }
}
</script>